import {useQuery} from '@tanstack/react-query';
import {LocationDto} from '../../generated/models/LocationDto';
import {LocationTagsCache} from '../constants/queryCacheKey';
import {locationEndpoint} from '../constants/endpoints';
import {apiRequest} from '../services/api';

export const useQueryLocationTags = () => {
  return useQuery<LocationDto[] | null>({
    queryKey: [LocationTagsCache],
    queryFn: async (): Promise<LocationDto[] | null> => {
      const response = await apiRequest<LocationDto[]>(
        {
          method: 'GET',
          endpoint: locationEndpoint,
        },
        {
          errorMessage: 'Failed to fetch locations',
          defaultValue: null,
          shouldPrintLogs: false,
        },
        true,
      );

      return response?.data ?? null;
    },
    staleTime: 1000 * 60 * 60, // one hour
  });
};
